import { computed, type Ref, unref, type MaybeRef } from 'vue';

export function useJumpToInitialPage(
  initialPage: MaybeRef<number | string | undefined>,
  currentPage: Ref<number | undefined>,
  goToPage: (page: number) => void,
) {
  const startPage = computed(() => {
    const page = unref(initialPage);

    if (page == null) {
      return undefined;
    }

    if (typeof page === 'string') {
      return parseInt(page, 10);
    }

    return page;
  });

  const jumpToStartPage = () => {
    if (startPage.value == null || currentPage.value === startPage.value) {
      return;
    }

    goToPage(startPage.value);
  };

  return {
    startPage,
    jumpToStartPage,
  };
}
